import React from "react";
import "./todosError.css";

function TodosError() {
  return <p>Error inesperado al cargar los TODO's</p>;
}

export { TodosError };
